import { Header } from './../../../components/Tags/types'

export const orderItems = (items: Header[]): Header[] => {
  // Prioritized groups in order: EBIKE, SYM, EMAX
  const groupsOrder = ['c743b810-fc9f-11e9-a4f8-8b0c496613bc', '157160b0-fca0-11e9-a6e1-efe08ff309cc', '1f3c6ac0-fca1-11e9-ba80-330a612f0d06']
  const prioritizedGroups = groupsOrder.reduce((acc: any[], prioritizedGroupID: string) => {
    const group = items.find((group: any) => group.value === prioritizedGroupID)
    return [...acc, group].filter(g => !!g)
  }, [])
  const remainder = items.filter((group: any) => !groupsOrder.some(id => id === group.id))

  return [...prioritizedGroups, ...remainder]
}
